import React from "react";
import search from "svg/search.svg";
export const TableTitle = (props) => {
  const { countTitle, searchResultsLength, searchFilterValue, handleSearchFilter, displaySearchFilter } = props;
  const searchResultsCount =
    searchResultsLength > 0 ? (searchResultsLength < 10 ? "0" + searchResultsLength : searchResultsLength) : "0";
  return (
    <div className="section-one d-flex justify-content-between">
      <div className="d-flex section-one__results">
        <div className="section-one__results__heading">
          <span className="section-one__results__heading--text">{countTitle}:</span>
        </div>
        <div className="section-one__results__count">
          <span className="section-one__results__count--no">{searchResultsCount}</span>
        </div>
      </div>
      <div className="switch-toggle d-flex align-items-center">
        {displaySearchFilter && (
          <div className="section-one__filter">
            <input
              type="text"
              className="section-one__filter--input w-100"
              placeholder="Filter"
              value={searchFilterValue}
              onChange={handleSearchFilter}
            />
            <img src={search} alt={"search-icon"} className="section-one__filter--icon" />
          </div>
        )}
      </div>
    </div>
  );
};
